/* TRANSFERS */
export const GET_TRANSFERS = 'GET_TRANSFERS';
export const GET_TRANSFERS_SUCCESS = 'GET_TRANSFERS_SUCCESS';
export const GET_TRANSFERS_FAIL = 'GET_TRANSFERS_FAIL';

export const GET_STATUS_TRANSFERS = 'GET_STATUS_TRANSFERS';
export const GET_STATUS_TRANSFERS_SUCCESS = 'GET_STATUS_TRANSFERS_SUCCESS';
export const GET_STATUS_TRANSFERS_FAIL = 'GET_STATUS_TRANSFERS_FAIL';

export const GET_COMPLETED_TRANSFERS = 'GET_COMPLETED_TRANSFERS';
export const GET_COMPLETED_TRANSFERS_SUCCESS = 'GET_COMPLETED_TRANSFERS_SUCCESS';
export const GET_COMPLETED_TRANSFERS_FAIL = 'GET_COMPLETED_TRANSFERS_FAIL';

export const GET_FILTERED_TRANSFERS_MOSCOW = 'GET_FILTERED_TRANSFERS_MOSCOW';
export const GET_FILTERED_TRANSFERS_MOSCOW_SUCCESS = 'GET_FILTERED_TRANSFERS_MOSCOW_SUCCESS';
export const GET_FILTERED_TRANSFERS_MOSCOW_FAIL = 'GET_FILTERED_TRANSFERS_MOSCOW_FAIL';

export const ADD_TRANSFER = 'ADD_TRANSFER';
export const ADD_TRANSFER_SUCCESS = 'ADD_TRANSFER_SUCCESS';
export const ADD_TRANSFER_FAIL = 'ADD_TRANSFER_FAIL';

export const UPDATE_TRANSFER = 'UPDATE_TRANSFER';
export const UPDATE_TRANSFER_SUCCESS = 'UPDATE_TRANSFER_SUCCESS';
export const UPDATE_TRANSFER_FAIL = 'UPDATE_TRANSFER_FAIL';

export const DELETE_TRANSFER = 'DELETE_TRANSFER';
export const DELETE_TRANSFER_SUCCESS = 'DELETE_TRANSFER_SUCCESS';
export const DELETE_TRANSFER_FAIL = 'DELETE_TRANSFER_FAIL';

/* TRANSFERS MOSCOW */
export const GET_TRANSFERS_MOSCOW = 'GET_TRANSFERS_MOSCOW';
export const GET_TRANSFERS_MOSCOW_SUCCESS = 'GET_TRANSFERS_MOSCOW_SUCCESS';
export const GET_TRANSFERS_MOSCOW_FAIL = 'GET_TRANSFERS_MOSCOW_FAIL';

export const GET_TRANSFERS_MOSCOW_LIST = 'GET_TRANSFERS_MOSCOW_LIST';
export const GET_TRANSFERS_MOSCOW_LIST_SUCCESS = 'GET_TRANSFERS_MOSCOW_LIST_SUCCESS';
export const GET_TRANSFERS_MOSCOW_LIST_FAIL = 'GET_TRANSFERS_MOSCOW_LIST_FAIL';

export const ADD_TRANSFER_MOSCOW = 'ADD_TRANSFER_MOSCOW';
export const ADD_TRANSFER_MOSCOW_SUCCESS = 'ADD_TRANSFER_MOSCOW_SUCCESS';
export const ADD_TRANSFER_MOSCOW_FAIL = 'ADD_TRANSFER_MOSCOW_FAIL';

export const UPDATE_TRANSFER_MOSCOW = 'UPDATE_TRANSFER_MOSCOW';
export const UPDATE_TRANSFER_MOSCOW_SUCCESS = 'UPDATE_TRANSFER_MOSCOW_SUCCESS';
export const UPDATE_TRANSFER_MOSCOW_FAIL = 'UPDATE_TRANSFER_MOSCOW_FAIL';

export const DELETE_TRANSFER_MOSCOW = 'DELETE_TRANSFER_MOSCOW';
export const DELETE_TRANSFER_MOSCOW_SUCCESS = 'DELETE_TRANSFER_MOSCOW_SUCCESS';
export const DELETE_TRANSFER_MOSCOW_FAIL = 'DELETE_TRANSFER_MOSCOW_FAIL';

/* TRANSFERS SHIPPING*/
export const GET_TRANSFERS_PRIORITY = 'GET_TRANSFERS_PRIORITY';
export const GET_TRANSFERS_PRIORITY_SUCCESS = 'GET_TRANSFERS_PRIORITY_SUCCESS';
export const GET_TRANSFERS_PRIORITY_FAIL = 'GET_TRANSFERS_PRIORITY_FAIL';

export const ADD_TRANSFER_PRIORITY = 'ADD_TRANSFER_PRIORITY';
export const ADD_TRANSFER_PRIORITY_SUCCESS = 'ADD_TRANSFER_PRIORITY_SUCCESS';
export const ADD_TRANSFER_PRIORITY_FAIL = 'ADD_TRANSFER_PRIORITY_FAIL';

export const UPDATE_TRANSFER_PRIORITY = 'UPDATE_TRANSFER_PRIORITY';
export const UPDATE_TRANSFER_PRIORITY_SUCCESS = 'UPDATE_TRANSFER_PRIORITY_SUCCESS';
export const UPDATE_TRANSFER_PRIORITY_FAIL = 'UPDATE_TRANSFER_PRIORITY_FAIL';

export const DELETE_TRANSFER_PRIORITY = 'DELETE_TRANSFER_PRIORITY';
export const DELETE_TRANSFER_PRIORITY_SUCCESS = 'DELETE_TRANSFER_PRIORITY_SUCCESS';
export const DELETE_TRANSFER_PRIORITY_FAIL = 'DELETE_TRANSFER_PRIORITY_FAIL';

export const GET_TRANSFERS_SHIPPING = 'GET_TRANSFERS_SHIPPING';
export const GET_TRANSFERS_SHIPPING_SUCCESS = 'GET_TRANSFERS_SHIPPING_SUCCESS';
export const GET_TRANSFERS_SHIPPING_FAIL = 'GET_TRANSFERS_SHIPPING_FAIL';

export const UPDATE_TRANSFER_MOSCOW_DATA = 'UPDATE_TRANSFER_MOSCOW_DATA';
export const UPDATE_TRANSFER_MOSCOW_DATA_SUCCESS = 'UPDATE_TRANSFER_MOSCOW_DATA_SUCCESS';
export const UPDATE_TRANSFER_MOSCOW_DATA_FAIL = 'UPDATE_TRANSFER_MOSCOW_DATA_FAIL';

export const DELETE_TRANSFER_SHIPPING = 'DELETE_TRANSFER_SHIPPING';
export const DELETE_TRANSFER_SHIPPING_SUCCESS = 'DELETE_TRANSFER_SHIPPING_SUCCESS';
export const DELETE_TRANSFER_SHIPPING_FAIL = 'DELETE_TRANSFER_SHIPPING_FAIL';
/* AGENTS */
export const GET_AGENTS = 'GET_AGENTS';
export const GET_AGENTS_SUCCESS = 'GET_AGENTS_SUCCESS';
export const GET_AGENTS_FAIL = 'GET_AGENTS__FAIL';

export const ADD_AGENT = 'ADD_AGENT';
export const ADD_AGENT_SUCCESS = 'ADD_AGENT_SUCCESS';
export const ADD_AGENT_FAIL = 'ADD_AGENT_FAIL';

export const UPDATE_AGENT = 'UPDATE_AGENT';
export const UPDATE_AGENT_SUCCESS = 'UPDATE_AGENT_SUCCESS';
export const UPDATE_AGENT_FAIL = 'UPDATE_AGENT_FAIL';

export const DELETE_AGENT = 'DELETE_AGENT';
export const DELETE_AGENT_SUCCESS = 'DELETE_AGENT_SUCCESS';
export const DELETE_AGENT_FAIL = 'DELETE_AGENT_FAIL';

export const SHOW_LOADING = 'SHOW_LOADING';
export const HIDE_LOADING = 'HIDE_LOADING';
